var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.headingTag,{tag:"component"},[_vm._v(" "+_vm._s(_vm.sectionTitle)+" "),(_vm.sectionSlug)?_c('small',[_c('router-link',{attrs:{"to":{
          name: 'PostsSection',
          params: { sectionSlug: _vm.sectionSlug }
        }}},[_vm._v(" → ")])],1):_vm._e()]),_vm._l((_vm.postList),function(post){return _c('NewsPost',{key:post.id,staticClass:"mb-2",attrs:{"newsPost":post}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }